export default __webpack_public_path__ + "static/flutter_service_banner-cf85e6157d97df227073229ef163cb99.svg";